export function getRelevantPricesUpdatedAt(timestamps: Array<number | undefined>) {
  const validTimestamps = timestamps.filter((timestamp): timestamp is number => timestamp !== undefined);

  if (validTimestamps.length === 0) {
    return undefined;
  }

  return Math.min(...validTimestamps);
}

export function getRelevantPricesUpdatedAtForSwap(fromTokenUpdatedAt?: number, toTokenUpdatedAt?: number) {
  return getRelevantPricesUpdatedAt([fromTokenUpdatedAt, toTokenUpdatedAt]);
}

export function getRelevantPricesUpdatedAtForPosition(indexTokenUpdatedAt?: number) {
  return getRelevantPricesUpdatedAt([indexTokenUpdatedAt]);
}
